import type { components } from "@/api/schema";

export type PlanStep = components["schemas"]["OrderPlanStepOutput"];
export type PlanStatus =
	| "pending"
	| "replaced"
	| "notRun"
	| "running"
	| "success"
	| "missed"
	| "failed"
	| "unsold";

/** A closed step of the latest batch did not run because the order stopped, not because a newer
 * batch replaced it. */
export function planStatus(step: PlanStep, latestBatchId?: string): PlanStatus {
	switch (step.state) {
		case "IN_PROGRESS":
			return "running";
		case "SUCCESS":
			return "success";
		case "MISSED":
			return "missed";
		case "SNIPED_BUT_NOT_SOLD":
			return "unsold";
		case "BOUGHT_BUT_NOT_LISTED":
		case "FAIL_TO_EXECUTE":
			return "failed";
		default:
			if (!step.superseded_at) return "pending";
			return step.batch_id === latestBatchId ? "notRun" : "replaced";
	}
}

export function groupPlan(steps: PlanStep[]): PlanStep[][] {
	const groups: PlanStep[][] = [];
	for (const step of steps) {
		const last = groups[groups.length - 1];
		if (
			step.method === "QUICK_SELL" &&
			last?.[0].method === "QUICK_SELL" &&
			last[0].batch_id === step.batch_id
		) {
			last.push(step);
		} else {
			groups.push([step]);
		}
	}
	return groups;
}
